
    import '/opt/buildhome/repo/packages/x/components/mermaid/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["mermaid-demo-basic","mermaid-demo-custom-header","mermaid-demo-header-actions","mermaid-demo-with-xmarkdown","mermaid-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/mermaid/index.en-US.md?type=demo')
};